import React from "react";
import { Button } from "@components";
import { SchemaForm } from "@components";
import type { EditModals } from "./types";

const MoveModal = (props: EditModals) => (
  <SchemaForm
    schema={props.schema}
    formData={{}}
    onSubmit={props.onSubmit}
    uiSchema={props.uiSchema}
  >
    <div className="d-flex justify-content-center pt-5">
      <Button color="secondary" className="w-25 mr-5" onClick={props.onCancel}>
        {props.t("CANCEL")}
      </Button>
      <Button type="submit" className="w-50">
        {props.t("MOVE_BRANCH")}
      </Button>
    </div>
  </SchemaForm>
);

export default MoveModal;
